/**
 * Release notes module.
 *
 * Releases are now served from the platform via RPC (ReleaseService) and
 * fetched on demand by ChangeLogTimeline using the useService hook.
 *
 * `latestVersion` is a mutable module-level variable initialized to "0".
 * It is updated by ChangeLogTimeline after the first successful fetch so that
 * synchronous consumers (ChangeLogTabs, WelcomeTab) get the correct value.
 */

/** Latest known release version. Starts as "0" until the first fetch completes. */
export let latestVersion: string = "0"

/** Update the cached latest version — called after RPC fetch. */
export function setLatestVersion(version: string): void {
  latestVersion = version
}
